import type React from 'react';
import styled, { css } from 'styled-components';

// Default styles
export const DEFAULT_STYLES = css`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

/**
 * Props
 */
export type PageWrapperProps = React.HTMLAttributes<Element>;

/**
 * PageWrapper
 *
 * This component is primarily style oriented. It is intended to be used
 * to wrap a page, such as the Data Practices or Take Control page, and to
 * provide a standard set of styling for it.
 *
 * If you want to change the component being used, leverage styled-components
 * `withComponent(ELEM)` function to keep the styles.
 *
 * If you want to extend the styles being applied, leverage styled-components
 * `extend(...)` function.
 *
 * It's expected that this component will be used in conjunction w/ ContentWrapper
 * and PageTitle, like:
 *
 * ```
 *  <PageWrapper>
 *    <PageTitle>{localizedPageTitle}</PageTitle>
 *    <ContentWrapper>
 *      {...}
 *    </ContentWrapper>
 *  </PageWrapper>
 * ```
 */
export default styled.main<PageWrapperProps>`
  ${DEFAULT_STYLES}
`;
